"use client";
import React from 'react';
import Link from 'next/link';

const ValueProposition = () => {
  const benefits = [
    {
      icon: 'bi-mortarboard',
      title: 'الدورات التعليمية',
      description: 'احصل على وصول إلى دورات تعليمية مختارة من خبراء المجال مقدمة حصرياً لمجتمع فيجماوية',
      color: '#e9a700ff',
      link: '/courses'
    },
    {
      icon: 'bi-book',
      title: 'مناقشات ومقالات',
      description: 'احصل على وصول إلى مقالات وجلسات الخبراء لتطوير مهاراتك باستمرار',
      color: '#e9a700ff',
      link: '/sessions'
    },
    {
      icon: 'bi-clipboard-check',
      title: 'اختبر مهاراتك',
      description: 'اكتشف مستواك واحصل على توصيات تعليمية مخصصة من خلال اختباراتنا التفاعلية',
      color: '#e9a700ff',
      link: '/quizzes'
    },
    {
      icon: 'bi-calculator',
      title: 'إحسب قيمة مشاريعك',
      description: 'احسب قيمة مشاريعك بسهولة وسرعة وبدقة',
      color: '#e9a700ff',
      link: '/calc'
    },
    {
      icon: 'bi-star',
      title: 'عرض أعمالك',
      description: 'احصل على ملاحظات واعتراف بمشاريعك من خلال مشاركتها مع المجتمع',
      color: '#e9a700ff',
      link: '/design-reviews'
    },
    {
      icon: 'bi-trophy',
      title: 'المشاركة في التحديات',
      description: 'تنافس  وتعلم واربح جوائز من خلال المشاركة في تحديات المجتمع المميزة',
      color: '#e9a700ff',
      link: '/challenges'
    }
  ];

  return (
    <div id="value-proposition" className="my-5 py-5 mx-auto col-12 col-md-12 col-xxl-12 fade-in-up">
      <div className="text-center mb-5">
        <h2 className="fw-bold mb-3" style={{ fontSize: 'clamp(1.75rem, 5vw, 2.25rem)' }}>
          لماذا انضم إلى مجتمع فيجماوية؟
        </h2>
        <p className="text-muted" style={{ fontSize: 'clamp(1rem, 3vw, 1.125rem)' }}>
          اكتشف الفوائد التي تجعل مجتمعنا الخيار الأمثل لتطوير مسيرتك المهنية
        </p>
      </div>

      <div className="row g-4">
        {benefits.map((benefit, index) => (
          <div key={index} className="col-12 col-md-6 col-lg-4">
            <Link
              href={benefit.link}
              className="text-decoration-none"
            >
              <div
                className="card border-0 shadow-sm h-100 p-4 bg-light"
                style={{
                  borderRadius: '20px',
                  transition: 'all 0.3s ease',
                  background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = `0 12px 30px ${benefit.color}30`;
                  e.currentTarget.style.borderColor = benefit.color;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                  e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.1)';
                }}
              >
                <div className="d-flex align-items-start">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{
                      width: '60px',
                      height: '60px',
                      background: `linear-gradient(135deg, ${benefit.color}20 0%, ${benefit.color}10 100%)`,
                      flexShrink: 0
                    }}
                  >
                    <i
                      className={`bi ${benefit.icon}`}
                      style={{
                        fontSize: '1.75rem',
                        color: benefit.color
                      }}
                    />
                  </div>
                  <div className="flex-grow-1">
                    <h4
                      className="fw-bold mb-2"
                      style={{
                        fontSize: 'clamp(1.125rem, 3vw, 1.375rem)',
                        color: benefit.color
                      }}
                    >
                      {benefit.title}
                    </h4>
                    <p
                      className="text-muted mb-0"
                      style={{ fontSize: 'clamp(0.875rem, 2.5vw, 1rem)', lineHeight: '1.6' }}
                    >
                      {benefit.description}
                    </p>
                  </div>
                  <i
                    className="bi bi-arrow-left text-muted"
                    style={{ fontSize: '1.25rem', flexShrink: 0, marginTop: '0.5rem' }}
                  />
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      {/* CTA Section */}
      <div className="text-center mt-5">
        <Link
          href="/signup"
          className="btn btn-lg px-5 py-3 rounded-pill fw-bold"
          style={{
            background: 'linear-gradient(135deg, #FFD52E 0%, #FF8C00 100%)',
            border: 'none',
            color: '#000',
            fontSize: 'clamp(1rem, 3vw, 1.125rem)',
            boxShadow: '0 4px 15px rgba(255, 213, 46, 0.4)',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 8px 25px rgba(255, 213, 46, 0.5)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 15px rgba(255, 213, 46, 0.4)';
          }}
        >
          <i className="bi bi-person-plus-fill me-2"></i>
          ابدأ رحلتك معنا الآن
        </Link>
      </div>
    </div>
  );
};

export default ValueProposition;
